import { shallowRef } from "vue";

export const _navContentsComponent = shallowRef();

export function provideNavContents(component) {
  _navContentsComponent.value = component
}
